export const LinkWord = {
  textDecoration: "none",
  color: "#198754",
};
